import * as fromActions from './search-query.actions';
import { createReducer, on } from '@ngrx/store';
import {RequestBodyModel} from '@app/models/client/request-body.model';

export interface SearchQueryState {
  entity: RequestBodyModel;
  loading: boolean;
  error: string;
}

const initialState: SearchQueryState = {
  entity: null,
  loading: null,
  error: null,
};

export const reducer = createReducer(
  initialState,
  on(
    fromActions.UpdateSearchQuery,
    (
      state,
      payload: {
        searchQuery: RequestBodyModel
      }
    ) => ({
      ...state,
      loading: false,
      entity: payload?.searchQuery,
    })
  )
);
